import styled from 'styled-components';
import WithDirection from "../../../../config/withDirection";

const StyleWrapper = styled.div`
    align-self: baseline;
    display: flex;
    flex-direction: column;
    position: relative;
    padding: 28px;
    padding-bottom: 42px;
    background-color: #fff;

    .header-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    
    .rating-emoji { font-size: 32px; }
    
    .author span {
        display: inline-block;
        min-width: 130px;
        padding: 4px 14px;
        background-color: #a565bc;
        text-align: center;
        color: #fff;
        border-radius: 30px;
    }

    .title {
        margin-top: 14px;
        margin-bottom: 14px;
        border-bottom: 1px solid #eee;
        padding-bottom: 7px;
        min-height: 70px;
        font-size: larger;
        font-weight: 700;
    }

    .ratings {
        position: absolute;
        right: 28px;
        bottom: 14px;
        font-size: 14px;
        color: #adff2f;
    }

    @media screen and (min-width: 481px) {
        .content.collapsed {
            position: relative;
            padding-top: 50%;
        }
        .content.collapsed p {
            position: absolute;
            top: 0;
            left: 0;
            max-height: 100%;
            overflow: hidden;
        }

        .content.collapsed {
            position: relative;
            padding-top: 50%;
        }
        .content.collapsed p {
            position: absolute;
            top: 0;
            left: 0;
            max-height: 100%;
            overflow: hidden;
        }
    }
`;
export default WithDirection(StyleWrapper);


// WEBPACK FOOTER //
// ./src/containers/AsoAnalytic/ScoreSummary/ReviewBlock/Wrapper.js